import ToastNotificationInterface from "@app/Interface/ToastNotificationInterface";

export default class IdContextManager {

    /**
     * If any notifications, get the highest id and increment by 1
     * otherwise return 1
     * 
     * @param notifications 
     * @returns 
     */
    static incrementToastNotificationId = (notifications: ToastNotificationInterface[]): number => {

        // default id value
        let newId = 1;

        const highestNotification = notifications.length
            ? notifications.reduce((prev, current) => {
                return (prev.id > current.id) ? prev : current;
            })
            : null;

        // if we found the highest notification,
        // increment the id
        if (highestNotification) {

            newId = highestNotification.id + 1;

        }

        return newId;

    }

}